import { makeStyles } from '@material-ui/core/styles'

export const bottomBarStyle = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '170px',
    background: theme.palette.common.white,
    borderTop: 2,
    borderTopColor: theme.palette.primary.main,
    borderTopStyle: 'solid'
  },
  closeButton: {
    position: 'absolute',
    color: theme.palette.geoColors.headerText.main,
    right: 0,
    top: 0,
    zIndex: 1000
  },
  closeButtonIcon: {
    color: theme.palette.geoColors.topBar.dark
  }
}))
